import { useState, useEffect } from 'react';
import { TaxTask } from '../types';
import { subscribeToTasks } from '../services/firestoreService';
import { useAuth } from '../context/AuthContext';

export const useTaxCaseTasks = (caseId: string | undefined) => {
  const [tasks, setTasks] = useState<TaxTask[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { firmId } = useAuth();

  useEffect(() => {
    if (!caseId) {
      setTasks([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    const unsub = subscribeToTasks(firmId || 'hannah-financial-demo', caseId, (newTasks) => {
      setTasks(newTasks);
      setLoading(false);
    });

    return () => unsub();
  }, [caseId, firmId]);

  return { tasks, loading, error };
};
